/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        version="1.1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#4a4a4a"
          d="M15.14 12.62a.34.34 0 0 0 .11-.27v-2.27a.28.28 0 0 0-.11-.23.46.46 0 0 0-.27-.08.42.42 0 0 0-.26.08.3.3 0 0 0-.09.23v2.27a.37.37 0 0 0 .09.27.31.31 0 0 0 .26.09.38.38 0 0 0 .27-.09ZM16.75 16.92a.65.65 0 0 1 .55.24 1.13 1.13 0 0 1 .19.71V20a1 1 0 0 1-.18.62.62.62 0 0 1-.51.21.87.87 0 0 1-.4-.08 1 1 0 0 1-.32-.25v.29h-.77v-5.17h.77v1.66a1.12 1.12 0 0 1 .32-.28.79.79 0 0 1 .35-.08Zm0 3v-2a.45.45 0 0 0-.08-.3.29.29 0 0 0-.23-.1.53.53 0 0 0-.17 0 .79.79 0 0 0-.15.12V20a.73.73 0 0 0 .18.14.39.39 0 0 0 .18 0 .29.29 0 0 0 .21-.08.43.43 0 0 0 .02-.18ZM9.62 16.37h.88v4.4h.85v-4.4h.89v-.75H9.62v.75zM14 19.85a1.51 1.51 0 0 1-.23.21.49.49 0 0 1-.22.08.18.18 0 0 1-.15-.06.34.34 0 0 1-.05-.2V17h-.76v3.17a.8.8 0 0 0 .14.51.45.45 0 0 0 .39.17.91.91 0 0 0 .44-.12 1.58 1.58 0 0 0 .44-.35v.42h.76V17H14Z"
          className="icon-fill"
          fillRule="evenodd"/>
        <path
          fill="#4a4a4a"
          d="M22.5 19.6a2.74 2.74 0 0 1-2.74 2.74h-9.52A2.74 2.74 0 0 1 7.5 19.6v-2.21a2.74 2.74 0 0 1 2.74-2.74h9.52a2.74 2.74 0 0 1 2.74 2.74ZM11.31 7.66l.62 2.27H12l.6-2.27h1L12.45 11v2.35h-1v-2.26l-1.11-3.43Zm2.33 2.45a1 1 0 0 1 .36-.78 1.41 1.41 0 0 1 .93-.28 1.28 1.28 0 0 1 .87.3 1 1 0 0 1 .34.78v2.16a1.08 1.08 0 0 1-.33.84 1.47 1.47 0 0 1-1.82 0 1.11 1.11 0 0 1-.33-.85Zm3.17-1h.85v3.21a.29.29 0 0 0 .06.21.18.18 0 0 0 .17.07.51.51 0 0 0 .24-.09 1.09 1.09 0 0 0 .26-.22V9.15h.86v4.18h-.86v-.46a1.75 1.75 0 0 1-.49.39 1 1 0 0 1-.49.14.56.56 0 0 1-.45-.19.89.89 0 0 1-.15-.56ZM0 15A15 15 0 1 0 15 0 15 15 0 0 0 0 15Z"
          className="icon-fill"
          fillRule="evenodd"/>
        <path
          fill="#4a4a4a"
          d="M19.34 18.37h-.67V18a.61.61 0 0 1 .08-.34.31.31 0 0 1 .26-.1.28.28 0 0 1 .25.1.53.53 0 0 1 .08.34Zm-.3-1.5a1.18 1.18 0 0 0-.83.31 1.1 1.1 0 0 0-.32.81v1.7a1.25 1.25 0 0 0 .29.87 1.06 1.06 0 0 0 .81.31 1.17 1.17 0 0 0 .85-.29 1.25 1.25 0 0 0 .29-.89v-.19h-.79v.17a.85.85 0 0 1-.07.44.34.34 0 0 1-.27.1.27.27 0 0 1-.25-.12.83.83 0 0 1-.08-.42V19h1.46v-1a1.13 1.13 0 0 0-.29-.83 1.06 1.06 0 0 0-.8-.29Z"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>
    );
  }
}

Icon.displayName = 'YoutubeIcon';

export default Icon;
